<app-widget-option [categories]="['LAYERS']" [label]="'PERCENT'" [limitedTo]="['gauge']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).gaugePercent " (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>